var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Ella")]),_c('h2',[_vm._v("v"+_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }